import { ClientError } from '~/errors';

import { Logger } from './logging';
import { sanitizeTagValue } from './instrumentation';

export const MAX_RETRIES = 3;

/**
 * Determines whether to retry a query based on the error and failure count.
 *
 * @param operation - The operation that failed (e.g. "fetch user profile", "fetch periods", etc.)
 * @param failureCount - The number of times the operation has failed
 * @param error - The error that occurred
 * @param log - The logger to use
 * @returns `true` if the operation should be retried, `false` otherwise
 */
export function determineRetryAndMaybeLog({
  operation,
  failureCount,
  error,
  log,
}: {
  operation: string;
  failureCount: number;
  error: unknown;
  log: Logger;
}): boolean {
  if (error instanceof ClientError) {
    return false;
  }
  log.warn(`Failed to ${operation}, retrying`, {
    errorMessage: sanitizeTagValue(error instanceof Error ? error.message : String(error)),
    failureCount,
  });
  return failureCount < MAX_RETRIES;
}
